import styled from "styled-components";
import { COLORS, DARK_THEME_COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import {
  Inner,
  Modal,
} from "../../../components/templates/modal/ModalTemplateStyled";
import { calcRem } from "styles/theme";
import { AccountItemScrollButton } from "pages/account/AccountStyled";

export const AlertWrapper = styled.div`
  width: 100%;
  ${FLEX.FlexStartCenter};
  flex-direction: column;
`;

export const Inners = styled(Inner)<{ isModal?: boolean }>`
  ${({ isModal }) =>
    isModal
      ? `
      width: 95%;
    `
      : `
      width: 100%;
    `}
  padding: 10px 0;
`;
export const AlertModal = styled(Modal)`
  border-radius: 15px;
  padding: 0;
  padding-bottom: 30px;
  ${mediaQuery.isDefault} {
    min-width: 960px;
  }
  ${mediaQuery.isMobile} {
    overflow: hidden;
    .bg-blue {
      padding: 0;
    }
  }
`;
export const AccountInfoListWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  padding-bottom: 10px;
  width: 100%;
  &.detail {
    padding: 5px 10px 0;
    &.modal {
      padding: 10px 20px 0;
    }
    ${mediaQuery.isMobile} {
      padding: 5px 0 0;
      &.modal {
        padding: 10px 0 0;
      }
    }
  }
`;
export const AccountInfoList = styled.div<{
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}>`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  cursor: pointer;
  font-size: ${calcRem(13)};
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}
  svg {
    margin: 0 -2px 0 4px;
  }
`;
export const AlertViewNoData = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  padding: 50px 0;
  color: ${COLORS.LIGHTGRAY};
  gap: 10px;
  font-weight: 500;
  font-size: ${calcRem(22)};
`;

export const AlertMapViewWrapper = styled.div`
  width: 100%;
  height: 100%;
  ${FLEX.FlexStartStart};
  /* gap: 14px; */
  flex-direction: column;
  padding: 0 14px;
  flex: 1;
`;
/**
 * Alert View Ppup
 */

export const CloseButton = styled.button`
  ${mediaQuery.isDefault} {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  ${mediaQuery.isMobile} {
    > img {
      height: 13px;
    }
  }
`;
export const AlertModalHeader = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  position: relative;

  ${mediaQuery.isDefault} {
    padding: 8px 0 10px;
  }

  ${mediaQuery.isMobile} {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 4px;
    padding: 8px;
  }
`;

export const HeaderInner = styled(Inners)`
  ${({ isModal }) =>
    isModal ? FLEX.FlexBetweenCenter : FLEX.FlexBetweenStart};
  flex-direction: row;
  margin: 0 auto;

  ${({ isModal }) =>
    isModal
      ? `
  padding-right: 30px;
  
  `
      : `
    padding: 10px;
  `}

  ${mediaQuery.isMobile} {
    padding: 0;

    .wep-app-link {
      ${FLEX.FlexEndCenter};
      gap: 8px;
    }
  }
`;

export const HeaderSub = styled.div<{ isModal?: boolean }>`
  gap: 8px;
  flex: 1;
  width: 100%;
  ${({ isModal }) => (isModal ? FLEX.FlexStartCenter : FLEX.FlexStartStart)};
  min-height: 32px;
  position: relative;

  ${mediaQuery.isMobile} {
    display: grid;
    grid-template-columns: 90px auto;
    justify-content: stretch;
    > div:last-of-type:not(.system-title) {
      grid-column: 1 / 3;
      justify-content: flex-end;
    }
  }

  .web-app-link-wrapper {
    flex: 0 0 auto;
    margin-left: -4px;
  }
  .system-title {
    flex: 1;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    gap: 6px;
    flex-direction: column;
    ${FLEX.FlexStartStart};

    > div:not(.web-app-link-wrapper) {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ${({ isModal }) =>
      isModal
        ? `
        flex-direction: column;
    
        `
        : `
        ${FLEX.FlexStartStart};
  `}
  }
  ${mediaQuery.isMobile} {
    .web-app-link-wrapper {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .system-name {
    ${({ isModal }) =>
      isModal &&
      `
        flex: 1;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    `}
  }
  .server-name {
    ${({ isModal }) =>
      isModal &&
      `
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
    `}
  }

  .title-wrapper {
    ${FLEX.FlexStartCenter};
    gap: 8px;
    align-items: baseline;
    flex: 1;
    width: 100%;
  }
`;

export const ActionInComment = styled.span`
  color: #828b9b;
  font-size: ${calcRem(12)};
  padding-left: 15px;

  > strong {
    font-weight: 500;
  }
`;

export const InnerContents = styled.div`
  width: 100%;
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 10px;
`;

export const CommmonWrapper = styled.div<{ isMap: boolean }>`
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};

  input {
    background-color: ${({ theme }) =>
      theme.value === "light" ? theme.COLORS.LIGHTGRAYBORDER : COLORS.PRIMARY2};
    color: ${({ theme }) => theme.COLORS.WHITE};
    padding: 8px;
    height: auto;
    border: 1px solid
      ${({ theme }) =>
        theme.value === "light" ? LIGHT_THEME_COLORS.BORDER : "#828c9e"};
    &::placeholder,
    #placeholder {
      color: ${({ theme }) =>
        theme.value === "light" ? "#6e7580" : "#ababab"};
    }
    &:disabled,
    &:disabled::placeholder {
      background-color: ${({ theme }) =>
        theme.value === "light"
          ? theme.COLORS.LIGHTGRAYBORDER
          : COLORS.PRIMARY2};
      border-color: ${({ theme }) =>
        theme.value === "light"
          ? LIGHT_THEME_COLORS.BORDER
          : DARK_THEME_COLORS.BORDER};
    }
  }

  .subtitle {
    font-size: ${calcRem(16)};
    font-weight: 400;
  }

  .select-box {
    max-width: 120px;
    ${FLEX.FlexEndCenter};
  }

  .column-box {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  ${({ isMap }) =>
    isMap
      ? `
      padding: 18px 0;

      .column-box {
        gap: 6px;
      }
      `
      : `
      padding: 14px 20px;
      border-radius: 6px;
    `}
`;
export const Edit = styled.span`
  ${FLEX.FlexEndCenter};
  gap: 6px;
  cursor: pointer;
  color: ${({ theme }) => theme.COLORS.SELECTED};
  /* flex: 1; */

  img {
    height: 14px;
  }
  ${mediaQuery.isMobile} {
    gap: 4px;
    img {
      height: 10px;
    }
  }
`;

export const AlertStatusStyled = {
  AlertStatusWrapper: styled.div`
    ${FLEX.FlexBetweenCenter};
    width: 100%;
    align-items: baseline;
    padding: 10px 0 20px;
  `,
  AlertStatusChange: styled.div`
    ${FLEX.FlexEndCenter};
    gap: 8px;

    span {
      color: ${COLORS.WHITE};
      font-size: ${calcRem(14)};
      white-space: nowrap;
    }
  `,
};

// AlertInfo
export const AlertInfoStyled = {
  AlertInfoWrapper: styled(CommmonWrapper)`
    ${FLEX.FlexBetweenStart};

    .causes {
      color: #ed7422;
    }

    .center {
      gap: 20px;
      ${mediaQuery.isMobile} {
        gap: 10px;
      }
    }

    ${({ isMap, theme }) =>
      isMap
        ? `
        flex-direction: column;
        border-bottom: 1px solid ${COLORS.BORDER};

        .center {
          flex-direction: row;
          margin-bottom: 14px;
        }
      `
        : `
        background-color: ${theme.COLORS.PRIMARY3};

      `}

    ${mediaQuery.isMobile} {
      flex-direction: column;
      gap: 10px;
    }
  `,
  AlertInfoItem: styled.li<{ isMap?: boolean }>`
    flex: 1;
    font-size: ${calcRem(14)};
    width: 100%;

    .subtitle {
      width: 100%;
      ${FLEX.FlexBetweenCenter};

      ${({ isMap }) =>
        isMap &&
        `
        justify-content:flex-start;
        gap: 10px;
      `}

      ${mediaQuery.isMobile} {
        justify-content: flex-start;
        gap: 8px;
      }
    }

    ul {
      ${FLEX.FlexStartStart};
      flex-direction: column;
      gap: 4px;
      width: 100%;

      > li {
        width: 100%;
        ${FLEX.FlexBetweenCenter};

        .ruleName {
          flex: 1;
        }
      }
    }
  `,
};

// TraceList

export const TraceListStyled = {
  TraceListWrapper: styled(CommmonWrapper)`
    ${FLEX.FlexStartStart};
    flex: 1;
    flex-direction: column;
    gap: 30px;
    width: 100%;

    .assign {
      width: 220px;
      max-width: 220px;
    }

    ${({ isMap, theme }) =>
      !isMap &&
      `
    background-color:  ${theme.COLORS.PRIMARY3}60;
    `}

    ${mediaQuery.isMobile} {
      gap: 10px;
    }
  `,
  AlertTraceInputWrapper: styled.div`
    ${FLEX.FlexStartCenter};
    flex: 3;
    gap: 6px;
    width: 100%;
    align-items: stretch;
    input[role="combobox"] {
      color: ${({ theme }) => theme.COLORS.WHITE} !important;
    }
  `,
  TraceList: styled.div`
    width: 100%;
    flex: 1;
    ${FLEX.FlexStartStart};
    flex-direction: column;
  `,
  AssignWrapper: styled.div<{ isMap: boolean }>`
    ${FLEX.FlexStartStart};
    width: 100%;
    gap: 16px;
    ${({ isMap }) =>
      isMap
        ? `
      flex-direction: column;
    `
        : `
    `}

    .technician {
      flex: 3;
    }

    .assignto {
      flex: 1;
      ${({ isMap }) =>
        isMap
          ? `

          border-bottom: 1px solid ${COLORS.BORDER};
        `
          : `
          padding-left: 16px;
          border-left: 1px solid ${COLORS.BORDER};
        `}
    }

    ${mediaQuery.isMobile} {
      flex-direction: column;

      .assignto {
        border: none;
        padding: 0;
      }
    }
  `,
  TraceTitle: styled.div<{ isMap: boolean }>`
    width: 100%;

    ${FLEX.FlexBetweenCenter};
    margin-bottom: 10px;

    .subtitle {
      flex: 1;
    }

    ${({ isMap }) =>
      isMap &&
      `
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
    `}

    ${mediaQuery.isMobile} {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  `,
  AssignBox: styled.div`
    ${FLEX.FlexBetweenCenter};
    width: 100%;
    height: 33px;
    line-height: 33px;
    gap: 8px;

    > .assignee-name {
      flex: 1;
      width: 100%;
      max-width: 160px;
      overflow: hidden;
      font-size: ${calcRem(14)};
      text-overflow: ellipsis;
      &.no-assignee {
        color: ${COLORS.GRAY};
      }
    }
    .assignee-button-wrapper {
      ${FLEX.FlexEndCenter};
      gap: 8px;

      button {
        color: ${({ theme }) => theme.COLORS.SELECTED};
      }
    }
  `,

  AlertTraceItemWrapper: styled.ul`
    width: 100%;
    height: calc(100% - 55px);
    max-height: calc(100% - 55px);
    overflow-y: auto;
    flex: 1;
    ${FLEX.FlexStartStart};
    flex-direction: column;

    > li {
      width: 100%;
      border-bottom: 1px solid ${COLORS.BORDER};
      padding: 8px 0;
      color: ${({ theme }) => COLORS.LIGHTGRAY};

      .title-wrapper {
        ${FLEX.FlexBetweenCenter};
      }

      .status {
        padding-top: 8px;
        font-size: ${calcRem(14)};
        * {
          display: inline;
        }
      }

      .trace-comment {
        padding-top: 4px;
        ${FLEX.FlexStartStart};
        gap: 6px;
        font-size: ${calcRem(14)};

        .comment {
          color: ${({ theme }) => theme.COLORS.WHITE};
        }
      }
    }
  `,
  NoteWrapper: styled.div`
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 4px;
    white-space: normal;
  `,
  NoteList: styled.ul`
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 4px;
  `,
};

// Alert Type List
export const AlertTypeListStyled = {
  Wrapper: styled.div`
    width: 100%;
    /* border: 1px solid red; */
    .react-multi-carousel-list {
      margin: 0 -2px;
    }
    .left-button {
      left: 0;
      right: unset;
    }

    .react-multi-carousel-track {
      gap: 10px;
      align-items: center;
    }
    .alert-item {
      flex: unset !important;
      width: unset !important;
    }
    .video-loss-image {
      svg {
        width: 20px;
        height: 20px;
      }
      p {
        display: none;
      }
    }
  `,
  List: styled.div`
    display: flex;
    transition: transform 0.3s ease-out;
    gap: 12px;
    cursor: grab;
    scroll-snap-align: center;
    width: fit-content;
  `,
  Item: styled.div`
    flex-shrink: 0;
    scroll-snap-align: start;
  `,
  AlertItem: styled.div<{ selected?: boolean; isMap: boolean }>`
    color: ${({ theme }) => theme.COLORS.WHITE};
    padding: 16px 14px;
    margin: 2px;
    ${FLEX.FlexBetweenEnd};
    flex-direction: column;
    border-radius: 6px;
    background-color: ${({ theme, isMap }) =>
      isMap
        ? theme.value === "light"
          ? "#fafafa"
          : theme.COLORS.PRIMARY1
        : theme.COLORS.PRIMARY3};
    cursor: pointer;

    min-height: 120px;
    width: 250px;

    .title {
      width: 100%;
      ${FLEX.FlexStartCenter};
      gap: 6px;

      span {
        font-size: ${calcRem(17)};
        font-weight: 400;
      }
    }

    ${({ selected }) =>
      selected &&
      `
      border-color: ${COLORS.RED};
      box-shadow: 0 0 0 2px ${COLORS.RED};
    `}

    ${({ isMap }) =>
      isMap &&
      `
        min-width: 180px;
        min-height: 120px;
        padding: 12px;


        .title {
          span {
            font-size: ${calcRem(16)};
          }
        }
      `}
  `,
  TitleWrapper: styled.div<{ isMap: boolean }>`
    ${FLEX.FlexBetweenCenter};
    width: 100%;

    .alert-type-icon {
      ${({ isMap }) =>
        isMap
          ? `
      height: 18px;
      `
          : `
      height: 22px;
      `}
      ${FLEX.FlexStartStart};

      > img {
        height: 100%;
      }
    }
  `,
  SelectWrapper: styled.div<{ isMap: boolean }>`
    ${FLEX.FlexBetweenCenter};
    width: 100%;
    gap: 6px;
    .select-box {
      min-width: 85px;
    }
    .video {
      ${({ isMap }) =>
        isMap
          ? `
          min-width: 100px;
      `
          : `
          min-width: 120px;
      `}
    }
  `,
  VideoLossThumbnail: styled.div`
    width: 82px;
  `,
  ScrollButton: styled(AccountItemScrollButton)`
    top: 0;
    color: ${({ theme }) => theme.COLORS.WHITE};
  `,
};
